import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'contactFunction',
  defaults: []
})
@Injectable()
export class ContactFunctionState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([ContactFunctionState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getNameById(id: number) {
    return createSelector([ContactFunctionState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).name;
    });
  }

  constructor(injector: Injector) {
    ContactFunctionState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<ContactFunctionState>) {
    this.service.getContactJobTitleDropdownData(ENDPOINTS.getContactFunctionList()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

}
